import {
  StyledCustomMenu,
  StyledCustomMenuAddChildButton,
  StyledCustomMenuChild,
  StyledCustomMenuChildNode,
  StyledCustomMenuChildNodes,
  StyledCustomMenuCloseButton,
  StyledCustomMenuFooter,
  StyledCustomMenuHeader,
  StyledCustomMenuTitle,
} from "./index.styled";
import { Descriptions, Typography } from "antd";
import { useTypedSelector, useTypedDispatch } from "@lib/redux";
import { randomColor } from "@lib/helpers/ColorHelper";
import { setAddNodeModal, setNodes } from "@lib/redux/slices/messageBot";
import { IoMdAdd, IoMdClose } from "react-icons/io";

export default function CustomMenu() {
  const dispatch = useTypedDispatch();
  const { selectedNode, nodes } = useTypedSelector((state) => state.messageBot);

  const handleSelectNode = (id?: string) => {
    dispatch(
      setNodes([
        {
          type: "select",
          id: id || null,
          selected: id ? true : false,
        },
      ]),
    );
  };

  const handleAddChild = () => {
    dispatch(
      setAddNodeModal({
        isOpen: true,
        parentId: selectedNode.id,
      }),
    );
  };

  if (!selectedNode) return null;

  return (
    <StyledCustomMenu>
      <StyledCustomMenuHeader>
        <StyledCustomMenuTitle>Node Menu</StyledCustomMenuTitle>
        <StyledCustomMenuCloseButton
          icon={<IoMdClose />}
          onClick={() => handleSelectNode()}
        />
      </StyledCustomMenuHeader>
      <Descriptions column={1}>
        <Descriptions.Item label="Node Type">
          <Typography>{selectedNode.type}</Typography>
        </Descriptions.Item>
        {Object.keys(selectedNode.data).map((key) => (
          <Descriptions.Item label={key}>
            <Typography>{selectedNode.data[key]}</Typography>
          </Descriptions.Item>
        ))}
      </Descriptions>

      <StyledCustomMenuChild>
        <Typography>Child Nodes</Typography>
        <StyledCustomMenuChildNodes>
          {nodes
            .filter((node) => node.parentId === selectedNode.id)
            .map((node, key) => (
              <StyledCustomMenuChildNode
                key={node.id}
                color={randomColor(key)}
                onClick={() => handleSelectNode(node.id)}
              >
                {node.data.label}
              </StyledCustomMenuChildNode>
            ))}
        </StyledCustomMenuChildNodes>
      </StyledCustomMenuChild>

      <StyledCustomMenuFooter>
        <StyledCustomMenuAddChildButton
          icon={<IoMdAdd />}
          onClick={() => handleAddChild()}
        >
          Add Child
        </StyledCustomMenuAddChildButton>
      </StyledCustomMenuFooter>
    </StyledCustomMenu>
  );
}
